import { RefObject, useEffect, useRef } from 'react'

import { useLayout } from 'contexts/LayoutProvider'

export interface IUseScroll {
  activeRefs: RefObject<HTMLDivElement>[]
  sheetRef: RefObject<HTMLDivElement>
}

export const useMultiModals = (show: boolean): IUseScroll => {
  const { activeRefs } = useLayout()

  const sheetRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (show) {
      activeRefs.push(sheetRef)
    } else {
      const index = activeRefs.indexOf(sheetRef)
      if (index > -1) {
        activeRefs.splice(index, 1)
      }
    }
  }, [show, activeRefs])

  return {
    activeRefs,
    sheetRef,
  }
}
